<template>
  <div class="row">
    <div class="col-3">
      <TournamentInfo />
    </div>
  </div>
</template>

<script>
import TournamentInfo from './panels/TournamentInfo/';
export default {
  name: 'TournamentInfoProfile',
  components: {
    TournamentInfo,
  },
};
</script>
